import React from "react";
import "./App.css";
import "./index.css";
import "./components/common-components/common_css/Form_Css.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Contact_Us from "./components/contact-us/Contact_Us";
import FAQ from "./components/faq/FAQ";
import About_Us from "./components/about_us/About_Us";
import Products from "./components/products/Products";
import Product_description from "./components/product-description/Product_description";
import ScrollToTop from "./components/common-components/ScrollToTop/ScrollToTop";
import TermsConditions from "./components/termsandconditions/Termsconditions";
import Privacypolicy from "./components/privacypolicy/Privacypolicy";
import Inner_Products from "./components/products/inner_products/Inner_Products";
import Factory from "./components/factory/Factory";
import Blogs from "./components/blogs/Blogs";
import Blog_Details from "./components/blog_details/Blog_Details";
import Recommended_Products from "./components/home/recommended-products/Recommended_Products";

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<Contact_Us />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/products" element={<Products />} />
        <Route path="/factory" element={<Factory />} />

        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:id" element={<Blog_Details />} />

        <Route path="/products/:categoryId" element={<Inner_Products />} />
        <Route path="/products/category/:title" element={<Inner_Products />} />
        <Route path="/product/:id" element={<Product_description />} />
        <Route
          path="/product-description/:id"
          element={<Product_description />}
        />

        <Route path="/termsandconditions" element={<TermsConditions />} />
        <Route path="/privacypolicy" element={<Privacypolicy />} />
        <Route
          path="/recommended-products"
          element={<Recommended_Products />}
        />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
